import OrderSummary from "../pdp-order-summary";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { staffInfoSelector } from "../../selectors/application";
import { hasLink } from "../../utils/siteUtils";
import { stockTypes } from "../../utils/lynkco-constants";
import { pdpLccSelector, pdpMarketSelector, pdpPlanTypeSelector, pdpSummarySelector } from "../../selectors/pdp";
import { useHistory } from "react-router-dom";
import { checkPdpStock, getStockLcc } from "../../services/pdpService";
import "./style.scss";
import "./confirmation.scss";
import {
  setPdpBillingAction,
  setPdpShippingAction,
  setPdpBundleAction,
  setPdpLccAction,
  setPdpPersonalInfoAction,
  setPdpPlanTypeAction,
  setPdpStockAction,
  setPdpSummaryAction,
  setPdpLoanOrderStatusAction,
  clearPdpAction,
  setPdpMarketAction,
  setPdpDeliveryAction,
  setPdpRiskCheckAction,
  setPdpTouchPointAction
} from "../../redux/actions";
import useQuery, { useQueryParams } from "../../utils/useQuery";
import { getOrderDetail } from "../../services/orderService";
import CheckoutErrorView from "../../sections/checkout-error-view";
import { getApiError, getCountryByCode, getMarketCountry } from "../../services/siteService";
import api from "../../utils/api";
import { getUserIdentity } from "../../services/userService";
import { S_LANG, webStorage } from "../../utils/webStorage";
import { appendQuery } from "../../utils/urlHelper";
import ConfirmationModal from "../../react-components/confirmation-modal";
import { useErrorView } from "../../hooks/useErrorView";
import { isEmptyObject } from "../../utils/siteUtils";
import { isBizNull } from "../../utils";
const PdpCheckoutTemplate = ({ fields, className, bodyClass, children, orderDetail, isNOCheckConfirmation = false, deliveryUnset }) => {
  /*Redux start*/
  const dispatch = useDispatch();
  const pdpLcc = useSelector(pdpLccSelector);
  const pdpSummary = useSelector(pdpSummarySelector);
  const pdpPlanType = useSelector(pdpPlanTypeSelector);
  const pdpMarket = useSelector(pdpMarketSelector);
  const staffInfo = useSelector(staffInfoSelector);

  const setPdpStock = payload => dispatch(setPdpStockAction(payload));
  const clearPdp = () => dispatch(clearPdpAction());
  /*Redux end*/
  const lang = webStorage.get(S_LANG);
  const query = useQuery();
  const [lid, lno] = useQueryParams("lid", "lno");
  const history = useHistory();
  const { template } = fields;
  const { orderSummary, pdpLink, deliveryLink, marketChangedConfirmation } = template?.fields || {};
  const { headingType, headingBody, subHeadingType, subHeadingBody, body, ctaName, colorScheme, iconName } = marketChangedConfirmation?.fields || {};
  const rootClasses = classNames(className, "grid", "car-checkout-wrapper");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { handleError, errorViewProps } = useErrorView();
  const orderSummaryProps = {
    fields: orderSummary?.fields || {},
    orderDetail
  };
  const confirmationProps = {
    heading: { type: headingType, html: headingBody },
    subHeading: { type: subHeadingType, html: subHeadingBody },
    body: body,
    showModal: showConfirmation,
    button: {
      buttonText: ctaName?.value,
      colorScheme,
      iconName,
      callback() {
        clearPdp();
        setShowConfirmation(false);
        window.location.href = appendQuery(`${window.location.origin}/${lang}/${pdpLink.value.href.replace(/^\/\w+-\w+\//gi, "")}`, query);
      }
    },
    onCloseClicked() {
      setShowConfirmation(false);
      window.location.href = window.location.href.replace(new RegExp(`\/${lang}\/`, "ig"), `/${pdpMarket}/`);
    }
  };

  useEffect(() => {
    initPage();
  }, []);
  const initPage = async () => {
    if (lid && lno) {
      if (!hasLink(deliveryLink.value.href)) {
        if (pdpMarket && pdpMarket !== lang && !isNOCheckConfirmation) {
          setShowConfirmation(true);
        }
      }
    } else {
      if ((pdpMarket === undefined || isEmptyObject(pdpSummary) || !pdpSummary?.modelConfigCode) && !isNOCheckConfirmation) {
        history.replace(template?.fields?.pdpLink?.value?.href);
      } else if (pdpMarket && pdpMarket !== lang && !isNOCheckConfirmation) {
        setShowConfirmation(true);
      }
      if (pdpLcc && pdpSummary && pdpPlanType) {
        const data = await getStockLcc();
        const stock = await checkPdpStock({
          lccId: data?.id,
          towbarState: pdpSummary?.towbarState,
          modelConfigCode: pdpSummary?.modelConfigCode,
          stocktype: stockTypes[pdpPlanType]
        });
        setPdpStock(stock);
      } else {
        setPdpStock([]);
      }
    }
  };

  return (
    <section className={rootClasses}>
      <div className={bodyClass}>{children}</div>
      <div className="summary-section">
        <OrderSummary {...orderSummaryProps} />
      </div>
      {errorViewProps.error && <CheckoutErrorView {...errorViewProps} />}
      <ConfirmationModal {...confirmationProps} />
    </section>
  );
};

export default PdpCheckoutTemplate;
